import { css } from '@emotion/react'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { memo } from 'react'
import { tokensPostQuickbuy } from '../../../../mfcLogic/tokens'
import Button from '../../../Buttons/Button'
import { AppStateType, useAppStateSelector } from '../../../Hooks/useAppState'
import { palette } from '../../../styles/colors'
import Error from '../common/Error'

const rootStyles = css({
    flexDirection: 'column' as const,
    overflow: 'hidden',
    display: 'flex',
    height: '100%',
    width: '100%',
})

const buttonColor = css({
    color: palette.greenMFC,
})

const QuickBuy = memo(() => {
    const pendingQuickbuy = useAppStateSelector(
        AppStateType.TOKENS,
        'pendingQuickbuy',
    )

    const {
        success = false,
        processor,
        product,
        description,
        code,
        processing = false,
        purchaseResponse,
    } = pendingQuickbuy

    if (success) {
        if (!purchaseResponse) {
            return (
                <div css={rootStyles}>
                    <DialogTitle>Confirm Purchase</DialogTitle>
                    <DialogContent>{`Purchase ${product.description} for $${product.amount} via ${processor.name}?`}</DialogContent>
                    <DialogActions>
                        {!processing && (
                            <Button
                                onClick={() => {
                                    tokensPostQuickbuy({
                                        product_id: product.id,
                                        processor_id: processor.id,
                                    })
                                }}
                                css={buttonColor}
                                size="medium"
                                border
                                clean
                            >
                                Purchase
                            </Button>
                        )}
                        {!!processing && (
                            <Button
                                css={buttonColor}
                                size="medium"
                                border
                                clean
                                disabled
                            >
                                Processing...
                            </Button>
                        )}
                    </DialogActions>
                </div>
            )
        } else {
            const {
                success: purchaseSuccess,
                product: purchasedProduct,
                processor: { name: purchasedProcessorName },
                purchase_result: { purchase_id },
                description: purchaseMessage,
                brief: purchaseBrief,
            } = purchaseResponse
            if (purchaseSuccess) {
                return (
                    <div css={rootStyles}>
                        <DialogTitle>Success</DialogTitle>
                        <DialogContent>
                            <div>
                                {`You have purchased ${
                                    purchasedProduct.description
                                } for $${purchasedProduct.amount}${
                                    purchasedProcessorName
                                        ? ` through ${purchasedProcessorName}`
                                        : ''
                                }.`}
                            </div>
                            {!!purchase_id && (
                                <div>
                                    {`Your transaction reference number is #${purchase_id}.`}
                                </div>
                            )}
                            <div>
                                Your token balance has now been updated. Thank
                                you!
                            </div>
                        </DialogContent>
                        <DialogActions></DialogActions>
                    </div>
                )
            } else {
                return (
                    <div css={rootStyles}>
                        <DialogTitle>Error</DialogTitle>
                        <DialogContent>
                            <p>
                                We were unable to carry out the purchase for the
                                following reason:{' '}
                                {purchaseBrief ? (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: purchaseBrief,
                                        }}
                                    ></span>
                                ) : (
                                    ''
                                )}
                                .
                            </p>
                            <p>
                                {purchaseMessage ? (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: purchaseMessage,
                                        }}
                                    ></span>
                                ) : (
                                    ''
                                )}
                            </p>
                        </DialogContent>
                        <DialogActions></DialogActions>
                    </div>
                )
            }
        }
    } else {
        return (
            <Error
                message={
                    description +
                    (code === 'invalid_price_point'
                        ? ' Type /quickbuy to see a list of available token packages.'
                        : code === 'no_prev_purchase' || code === 'no_processor'
                          ? ' In order to purchase with QuickBuy, you must first complete a regular purchase.'
                          : '')
                }
            />
        )
    }
})

export default QuickBuy
